// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { lazy } from 'react'
import { HulkTripsAreaId } from './HulkTripsAreaId'
import {
  HulkTripsAreaNavigation,
  HulkTripsAreaNavigationIcon,
} from './HulkTripsAreaNavigation'
import { HulkTripsAreaRoutes } from './HulkTripsAreaRoutes'

const LazyHulkTripsComponent = lazy(() => import('./HulkTripsArea'))

const HulkTripsComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyHulkTripsComponent />
  </SuspenseLoadingWrapper>
)

export const HulkTripsArea = {
  id: HulkTripsAreaId,
  Icon: HulkTripsAreaNavigationIcon,
  NavigationComponent: HulkTripsAreaNavigation,
  route: {
    path: HulkTripsAreaRoutes.route,
    component: HulkTripsComponent,
  },
}
